export const configuration ={
    sizePerPage: 100,
    
}